import { render } from "./CommunityDetail.vue?vue&type=template&id=11d12eaa&scoped=true"
import script from "./CommunityDetail.vue?vue&type=script&lang=js"
export * from "./CommunityDetail.vue?vue&type=script&lang=js"

import "./CommunityDetail.vue?vue&type=style&index=0&id=11d12eaa&scoped=true&lang=scss"
import "./CommunityDetail.vue?vue&type=style&index=1&id=11d12eaa&lang=scss"

import exportComponent from "/home/projects/endangeredlabs-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11d12eaa"]])

export default __exports__